module.exports = __webpack_public_path__ + "img/home-cat-1.e7745aaa.jpg";